import statuts from "../../api/statuts";

export default {
  namespaced: true,
  state: {
    items: [],
  },
  mutations: {
    setItems(state, items) {
      state.items = items;
    },
  },
  actions: {
    fetchAll({ commit }) {
      return statuts.get().then((response) => {
        commit("setItems", response.data);
        return response;
      });
    },
  },
};
